import globalServices from '../api/globalServices'
import { download } from '../utils/enerFunctions'

export const state = () => ({
  publicToken: null,
  loggedIn: false,
  user: null,
  requireTrial: null,
  requireAddInterest: null,
  requestedDownload: null,
  requestedDownloadPublicationTitle: null,
  content: null,
  footerContent: null,
  scenariosContent: null,
  currentPage: 'homepage',
  countries: [],
  regions: [],
  world: null,
  units: [],
  defaultApplicationPageId: 3,
  defaultChartZoneCodes: ['europe', 'asiepac', 'afriq', 'moy', 'amnord', 'aml', 'cei'],
  applicationWidth: null
  // ignoredZoneCodes: ['ueur', 'g7', 'ameriq', 'ocde', 'bric5'] // Zone only used for backend export
})

export const getters = {
  publicToken: (state) => {
    return state.publicToken
  },
  loggedIn: (state) => {
    return state.loggedIn
  },
  currentPage: (state) => {
    return state.currentPage
  },
  pages: (state) => {
    if (state.content === null) {
      return []
    }
    return state.content.pages
  },
  pageByRoutePath: (state, getters) => (routePath) => {
    return getters.pages.find(page => routePath === '/' + page.url + '.html')
  },
  defaultPagePath: (state, getters) => {
    const defaultPage = getters.pages.find(page => page.id === state.defaultApplicationPageId)
    return '/' + defaultPage.url + '.html'
  },
  defaultPageTitle: (state, getters) => {
    const defaultPage = getters.pages.find(page => page.id === state.defaultApplicationPageId)
    return defaultPage.title
  },
  categories: (state, getters) => {
    const returnedArray = []
    const defaultpages = getters.pages.filter(page => page.defaultCategoryPage === true)
    const n = defaultpages.length
    for (let i = 0; i < n; i++) {
      const page = defaultpages[i]
      const categoryName = page.category1
      const category = {
        id: page.id,
        title: page.category1,
        icon: page.icone,
        children: getters.pages.filter(page => page.category1 === categoryName),
        url: '/' + page.url + '.html'
      }
      returnedArray.push(category)
    }
    return returnedArray
  },
  countrySnapshotStructure: (state, getters) => {
    const returnedArray = []
    const defaultpages = getters.pages.filter(page => page.defaultCategoryPage === true)
    const n = defaultpages.length
    for (let i = 0; i < n; i++) {
      const page = defaultpages[i]
      const categoryName = page.category1
      const category = {
        id: page.id,
        title: page.category1,
        icon: page.icone,
        children: getters.pages.filter(page => page.category1 === categoryName && page.displayCountrySnapshot === true),
        url: '/' + page.url + '.html'
      }
      if (category.children.length > 0) {
        returnedArray.push(category)
      }
    }
    return returnedArray
  },
  footerContent: (state) => {
    if (state.footerContent === null) {
      return []
    }
    return state.footerContent
  },
  scenariosContent: (state) => {
    if (state.scenariosContent === null) {
      return []
    }
    return state.scenariosContent
  },
  // marketingContent: (state) => {
  //   if (state.marketingContent === null) {
  //     return []
  //   }
  //   return state.marketingContent
  // },
  world: (state) => {
    return state.world
  },
  countries: (state) => {
    return state.countries
  },
  regions: (state) => {
    return state.regions
  },
  zones: (state) => {
    const zones = [].concat(state.regions)
    zones.push(state.world)
    return zones
  },
  units: (state) => {
    return state.units
  },
  defaultChartZoneCodes: (state) => {
    return state.defaultChartZoneCodes
  },
  gtmUserData: (state) => {
    let userData = {
      user_id: ''
    }
    if (state.user !== null) {
      userData = {
        user_id: state.user.id,
        firstname: state.user.prenom,
        lastname: state.user.nom,
        email: state.user.mail
      }
    }
    return userData
  },
  requestedDownload: (state) => {
    return state.requestedDownload
  },
  isMobileLayout: (state) => {
    return state.applicationWidth < 992
  }
}

export const actions = {
  async nuxtServerInit (store, context) {
    const locale = context.app.i18n.locale
    await store.dispatch('initZones')
    await store.dispatch('initUnits')
    const pagesContent = () => import('~/data/pages-' + locale + '.json').then(m => m.default || m)
    const footer = require('~/data/footer-' + locale + '.json')
    const scenarios = require('~/data/scenarios.json')
    store.commit('INIT_CONTENT', await pagesContent())
    store.commit('INIT_FOOTER_CONTENT', footer)
    store.commit('INIT_SCENARIOS_CONTENT', scenarios)
  },

  async initZones ({ commit }) {
    const { data } = await globalServices.zones()
    const world = data.filter(zone => zone.nrdCode === 'monde')[0]
    const countries = data.filter(zone => zone.type === 'pays')
    const regions = data.filter(zone => zone.type !== 'pays' && zone.nrdCode !== 'monde')
    commit('INIT_WORLD', world)
    commit('INIT_COUNTRIES', countries)
    commit('INIT_REGIONS', regions)
  },
  async initUnits ({ commit }) {
    const { data } = await globalServices.units()
    commit('INIT_UNITS', data)
  },
  clearRequestedDownload ({ commit }) {
    commit('SET_REQUESTED_DOWNLOAD', null)
    commit('SET_REQUESTED_DOWNLOAD_PUBLICATION_TITLE', null)
  },
  setRequestedDownload ({ commit }, { fileName, publicationTitle }) {
    commit('SET_REQUESTED_DOWNLOAD', fileName)
    commit('SET_REQUESTED_DOWNLOAD_PUBLICATION_TITLE', publicationTitle)
  },
  async updateLoggedIn ({ commit, dispatch, state }, value) {
    commit('SET_LOGGED_IN', value)
    if (value === true) {
      const user = await this.$customer.getContact()
      commit('SET_USER', user)
      if (value === true && state.requestedDownload !== null) {
        const fileName = state.requestedDownload
        const publicationTitle = state.requestedDownloadPublicationTitle
        await dispatch('downloadFile', { fileName, publicationTitle })
      }
    } else {
      commit('SET_USER', null)
    }
  },
  async downloadFile ({ commit, dispatch, state }, { fileName, publicationTitle }) {
    download(await this.$eneroutlook.getXlsxFile(fileName), fileName)
    this.$gtm.push({
      event: 'download_free_publication',
      publication_name: fileName,
      publication_type: 'enerOutlook',
      user_logged: 'yes'
    })
    // save publication in erp
    this.$customer.savePublication(publicationTitle, this.$i18n.locale)
    dispatch('clearRequestedDownload')
    // TODO restore when subscription part done
    // create trial if needed
    if (state.requireTrial !== false) {
      const activeSubscriptions = await this.$customer.getActiveSubscriptions()
      const gedSubscription = activeSubscriptions.find(subscription => subscription.serviceCode === 'fcst')
      if (gedSubscription === undefined) {
        const activeTrials = await this.$customer.getActiveTrials()
        const gedTrial = activeTrials.find(trial => trial.serviceCode === 'fcst')
        if (gedTrial === undefined) {
          this.$customer.createTrial('fcst', 'EnerOutlook')
        } else {
          commit('SET_REQUIRE_TRIAL', false)
        }
      } else {
        commit('SET_REQUIRE_TRIAL', false)
      }
    }
  },
  updateApplicationWidth ({ commit }, width) {
    commit('UPDATE_APPLICATION_WIDTH', width)
  }
}

export const mutations = {
  INIT_PUBLIC_TOKEN (state, token) {
    state.publicToken = token
  },
  INIT_CONTENT (state, content) {
    state.content = content
  },
  INIT_FOOTER_CONTENT (state, footer) {
    if (footer.Forecast.elements.length === 0) {
      const defaultPages = state.content.pages.filter(page => page.displayInFooter === true)
      const n = defaultPages.length
      for (let i = 0; i < n; i++) {
        const page = defaultPages[i]
        const category = {
          intitule: page.footerTitle,
          url: '/' + page.url + '.html'
        }
        footer.Forecast.elements.push(category)
      }
    }
    state.footerContent = footer
  },
  INIT_SCENARIOS_CONTENT (state, content) {
    state.scenariosContent = content
  },
  INIT_COUNTRIES (state, countries) {
    state.countries = countries
  },
  INIT_REGIONS (state, regions) {
    state.regions = regions
  },
  INIT_WORLD (state, world) {
    state.world = world
  },
  INIT_UNITS (state, units) {
    state.units = units
  },
  SET_REQUESTED_DOWNLOAD (state, value) {
    state.requestedDownload = value
  },
  SET_REQUESTED_DOWNLOAD_PUBLICATION_TITLE (state, value) {
    state.requestedDownloadPublicationTitle = value
  },
  SET_LOGGED_IN (state, value) {
    state.loggedIn = value
    if (value === false) {
      state.requireTrial = null
    }
  },
  SET_USER (state, value) {
    state.user = value
  },
  SET_REQUIRE_TRIAL (state, value) {
    state.requireTrial = value
  },
  UPDATE_APPLICATION_WIDTH (state, value) {
    state.applicationWidth = value
  }
}
